export const PWA_UPDATE_BANNER_VISIBILITY_EVENT = 'app:pwaUpdateBannerVisibility';

export function emitPwaUpdateBannerVisibility(visible: boolean): void {
  window.dispatchEvent(
    new CustomEvent(PWA_UPDATE_BANNER_VISIBILITY_EVENT, { detail: { visible } })
  );
}
